<template>
    <div>
        <app-tabela
            idTabela="tblPenalidades"
            :itens="contrato.penalidades"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <div class="d-flex flex-row-reverse mb-3">
                    <btn-exportar
                        :contrato="contrato"
                        class="ml-1"
                    ></btn-exportar>
                    <btn-inserir
                        :contrato="contrato"
                        v-if="mostrarBtnInserir"
                        @obterPenalidadesAtualizadas="obterPenalidades()"
                    ></btn-inserir>
                </div>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar
                    :contrato="contrato"
                    :penalidade="data"
                    v-if="mostrarBtnAtualizar"
                    @obterPenalidadesAtualizadas="obterPenalidades()"
                ></btn-atualizar>
                <btn-excluir
                    :contrato="contrato"
                    :penalidade="data"
                    v-if="mostrarBtnExcluir"
                    @obterPenalidadesAtualizadas="obterPenalidades()"
                ></btn-excluir>
            </template>
            <template slot="valorMulta" slot-scope="data">
                <p class="text-right m-0">{{ data.valorMulta | currency }}</p>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import PenalidadesServicos from './PenalidadesServicos'
import BtnInserir from './BtnInserir'
import BtnAtualizar from './BtnAtualizar'
import BtnExcluir from './BtnExcluir'
import BtnExportar from './BtnExportar'

export default {
    components: {
        BtnInserir,
        BtnAtualizar,
        BtnExcluir,
        BtnExportar
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'tipoPenalidade',
                    label: 'Tipo da Penalidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataPenalidade',
                    label: 'Data da Penalidade',
                    sortable: true,
                    type: 'date'
                },
                {
                    key: 'valorMulta',
                    label: 'Valor da Multa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'recurso',
                    label: 'Recurso',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Última Atualização',
                    sortable: true,
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterPenalidades() {
            this.$store.dispatch('addRequest')
            PenalidadesServicos.obterPenalidades(
                this.$route.params.contratoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarPenalidades', response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter as penalidades',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {
        mostrarBtnInserir() {
            return this.$temAcessoView('CONT-PENAL-01')
        },

        mostrarBtnAtualizar() {
            return this.$temAcessoView('CONT-PENAL-02')
        },

        mostrarBtnExcluir() {
            return this.$temAcessoView('CONT-PENAL-03')
        }
    },

    watch: {}
}
</script>
